import dynamic from "next/dynamic";

export const SeoHead = dynamic(() => import("./component"));
